const GA_ID = 'G-YMN9F5KYL3';
const CONSENT_KEY = 'auth0expert_cookie_consent'; // 'accepted' | 'refused'

export function getConsent() {
  return localStorage.getItem(CONSENT_KEY);
}

export function setConsent(value) {
  localStorage.setItem(CONSENT_KEY, value);
}

export function initGA() {
  if (window._GA_LOADED) return;
  window._GA_LOADED = true;

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  window.gtag = function () { window.dataLayer.push(arguments); };
  window.gtag('js', new Date());
  window.gtag('config', GA_ID, {
    anonymize_ip: true,
    cookie_flags: 'SameSite=None;Secure',
  });
}

export function trackPage(path) {
  if (window.gtag) {
    window.gtag('event', 'page_view', { page_path: path });
  }
}
